// Górny pasek ekranów poza lekcją (ekran główny, nastrój, tydzień): profil z awatarem i liczby (seria, gwiazdki, słówka).
// „słówko/słówka/słówek” po polsku i „word/words” po angielsku — za przełącznikiem EN/PL.
import { enPlural } from '../lib/i18n.ts';
import { plPlural } from '../lib/plural.ts';
import type { AppCtx } from './ctx.ts';
import { h } from './dom.ts';
import { tx } from './i18n.ts';
import { renderLangToggle } from './langToggle.ts';
import { renderProfileBar } from './profileBar.ts';

export function renderHomeHead(ctx: AppCtx): HTMLElement {
  const progress = ctx.getProgress();
  const wordCount = Object.keys(progress.course?.items ?? {}).length; // słówka kursu (od patcha 48 jedyne; dawne `items` są nieużywane)
  const stats = h('div', { class: 'stats' },
    h('span', { class: 'chipstat', 'data-testid': 'streak' }, '🔥', h('strong', null, progress.streak)),
    h('span', { class: 'chipstat', 'data-testid': 'stars-total' }, '⭐', h('strong', null, progress.stars)),
    h('span', { class: 'chipstat', 'data-testid': 'words-total' }, '📚', h('strong', null, wordCount), ' ', tx(ctx, { en: enPlural(wordCount, 'word', 'words'), pl: plPlural(wordCount, 'słówko', 'słówka', 'słówek') })),
  );
  return h('div', { class: 'home-head' }, renderProfileBar(ctx), stats, renderLangToggle(ctx));
}
